// SSOLogin.js
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { apiURL } from '../config';

function SSOLogin() {
    const navigate = useNavigate();
    const { ssoLogin } = useAuth();
    const loginAttempted = useRef(false);

    const navigateRef = useRef(navigate);
    const ssoLoginRef = useRef(ssoLogin);

    useEffect(() => {
        const handleSSOLogin = async () => {
            if (loginAttempted.current) {
                return;
            }
            loginAttempted.current = true;

            try {
                const ssoInfo = localStorage.getItem('sso_key');

                if (!ssoInfo) {
                    throw new Error('未找到 SSO info');
                }

                const response = await fetch(`${apiURL}api/verify-sso-token`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({ sso_info: ssoInfo }),
                });

                if (response.ok) {
                    const userData = await response.json();
                    await ssoLoginRef.current(userData);
                    navigateRef.current('/sso-chatbot');
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.error || 'SSO 驗證失敗';
                    navigateRef.current('/sso-error', { state: { errorMessage } });
                }
            } catch (error) {
                navigateRef.current('/sso-error', { state: { errorMessage: error.message } });
            }
        };

        handleSSOLogin();
    }, []);

    return null;
}

export default SSOLogin;
